import StepDocuments from './components/StepDocuments';
import StepSettings from './components/StepSettings';
import StepShare from './components/StepShare';
import StepTemplate from './components/StepTemplate';
import { DATA_ROOM_RFI_FILE_TYPES } from 'router/subrouters/DataRoom/models/DataRoomRfi';

export const DOCUMENT_OPTIONS = Object.values(DATA_ROOM_RFI_FILE_TYPES).map(
  (value) => ({ value, label: `${value}_copy` }),
);

export type RfiCreateStep = { isCreatingOrEditingTemplate: boolean };

export const STEPS = [
  {
    Step: StepDocuments,
    title: 'specifyTheDocuments',
  },
  {
    Step: StepSettings,
    title: 'settings',
  },
  {
    Step: StepShare,
    title: 'shareThisRequest',
  },
  {
    Step: StepTemplate,
    title: 'makeTemplate',
  },
];
